import React, { useState, useEffect, useRef} from 'react';
import '../css/CompanyHouseDetails.css'
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  fetchCompanyDetails,
  setViewChouseDetails
} from '../slices/chouseSlice.js'

import chtypes from '../helpers/chouseenumerated.js'

const {formatDate, formatDateShort} = require('../helpers/dates.js')


function CompanyHouseInfo() {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(0)
  const [jsvisible,setjsVisible] = useState(false)
  const [openpdf, setOpenPdf] = useState(false)
  const [pdfhef, setPDFhref] = useState("")
  const isMobile = useMediaQuery('(max-width:768px)');

  const companyName = useSelector(state => state.chouse.companyName, shallowEqual);
  const companyNumber = useSelector(state => state.chouse.companyNumber, shallowEqual);
  const company = useSelector(state => state.chouse.company, shallowEqual);
  const filings = useSelector(state => state.chouse.filings, shallowEqual)
  const registered_office_address = useSelector(state => state.chouse.registered_office_address, shallowEqual)
  const auth = useSelector(state => state.auth, shallowEqual)
  const viewChouseDetails = useSelector(state => state.chouse.viewChouseDetails, shallowEqual)
  const updatedat = useSelector(state => state.chouse.updatedat, shallowEqual)
  const loaded = useSelector(state => state.chouse.loaded, shallowEqual)

  const lead = useSelector(state => state.data.rowdata, shallowEqual)

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue)
  };
  
  const formatOverDueAccs = () => {
    if(typeof company?.accounts?.overdue && company?.accounts?.overdue > "")
      return <span className='error'>{company?.accounts?.overdue}Overdue</span>
  }

  const formatOverDueConf = () => {
    if(typeof company?.confirmation_statement?.overdue && company?.confirmation_statement?.overdue > "")
      return <span className='error'>{company?.confirmation_statement?.overdue}Overdue</span>
  }

  if(company && Object.keys(company).length > 0 && companyNumber && typeof companyNumber !== 'undefined' )
    return (
        <div className='info' >
        <dl>
        <dt>Registered office address</dt>
        <dd className="text data" >{registered_office_address}</dd>
        </dl>

        <div className='grid-row' >
        <dl className="column-two-thirds">
            <dt>Company status</dt>
            <dd className="text data" >{chtypes.company_status[company.company_status] }</dd>
        </dl>
        </div>
        <div className="grid-row">
        <dl className="column-two-thirds">
            <dt>Company type</dt>
            <dd className="text data" >
            {chtypes.company_type[company.type]}
            </dd>
        </dl>

        <dl className="column-third">
            <dt id="company-birth-type">{chtypes.company_birth_type[company.type]}</dt>
            <dd className="data" >{formatDate(company.date_of_creation)}</dd>
        </dl>
        </div>    

        <div className="grid-row">
        <div className="column-half">
            <h2 ><strong>Accounts</strong></h2>
            <p>
            {typeof company.accounts.last_accounts === 'undefined' ?'First':'Next'} accounts made up to: <strong>{formatDate(company.accounts.next_made_up_to)}</strong><br/>
            due by <strong>{formatDate(company.accounts.next_due)}</strong> {formatOverDueAccs()}
            </p>
            {typeof company.accounts.last_accounts.made_up_to !== 'undefined' &&
            <p>
            Last accounts made up to <strong>{formatDate(company.accounts.last_accounts.made_up_to)}</strong>
            </p>
            }
        </div>
        <div className="column-half">
            <h2 ><strong>Confirmation statement</strong></h2>
            <p>
            {typeof company?.confirmation_statement?.last_made_up_to==='undefined'?'First':'Next'} statement date <strong>{formatDate(company?.confirmation_statement?.next_made_up_to)}</strong> <br/>
            due by <strong>{formatDate(company?.confirmation_statement?.next_due)}</strong> {formatOverDueConf()}
            </p>
            {typeof company?.confirmation_statement?.last_made_up_to !== "undefined" && 
            <p>
                Last statement dated <strong>{formatDate(company?.confirmation_statement?.last_made_up_to)}</strong>
            </p>
            }
        </div>
        </div>
        <h2 id="sic-title" >Nature of business (SIC)</h2>
        <ul >
        {company?.sic_codes?.map(item => (
        <li>
            <span id="sic0">
            {item} - {chtypes.sic_descriptions[item]}
            </span>
        </li>
        ))}
        </ul>
    </div>

    )
}

export default CompanyHouseInfo;
